import script from "./TimeExpiredActivation.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeExpiredActivation.vue?vue&type=script&setup=true&lang=js"

import "./TimeExpiredActivation.vue?vue&type=style&index=0&id=582b7d30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-582b7d30"]])

export default __exports__